import {FC} from 'react';

import {Icon, MenuItem, MenuItemProps, Typography, TypographyProps} from '@mui/material';

import {greenColors} from '../../layouts/theme/designSystem';

interface EmpionActionMenuItemsProps {
  menuItems:
    | {
        key: string;
        label: string;
        icon?: JSX.Element | string;
        onClick?: () => void;
        disabled?: boolean;
      }[]
    | undefined;
}

export const EmpionActionMenuItems: FC<EmpionActionMenuItemsProps & MenuItemProps & TypographyProps> = ({
  menuItems,
  ...props
}) => {
  return (
    <>
      {menuItems?.map((item) => (
        <MenuItem key={item.key} onClick={item?.onClick} disabled={item?.disabled} {...props}>
          {item?.icon && (
            <Icon
              sx={{
                marginRight: '10px',
                color: greenColors[700],
              }}
            >
              {item?.icon}
            </Icon>
          )}
          <Typography {...props}>{item?.label}</Typography>
        </MenuItem>
      ))}
    </>
  );
};
